<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>تصویر</th>
                    <th>نام مهره</th>
                    <th>نوع مهره</th>
                    <th>نیرو</th>
                    <th>زمان</th>
                    <th>وضعیت</th>
                    <th>دیفالت</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="skin in skins" :key="skin._id">
                    <td>
                      <img
                        v-if="skin.imageUrl"
                        :src="skin.imageUrl"
                        alt=""
                        style="max-height: 40px; max-width: 60px; object-fit: contain;"
                      />
                      <span v-else>-</span>
                    </td>
                    <td>{{ skin.skinName }}</td>
                    <td>{{ skinType[skin.skinCat] }}</td>
                    <td>{{ skin.force }}</td>
                    <td>{{ skin.time }}</td>
                    <td>{{ skin.isAvailable ? 'فعال' : 'غیر فعال' }}</td>
                    <td>{{ skin.isDefault ? 'اصلی' : 'فرعی' }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/skin', query: { id: skin._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import skinService from '../../../../services/skin';
export default {
  name: 'skins',
  data() {
    return {
      skins: [],
      skinType: {
        NationalTeam: 'تیم ملی',
        Other: 'دیگر',
        ClubTeam: 'تیم باشگاهی',
      },
    };
  },
  created() {
    this.getGrounds();
  },
  methods: {
    async getGrounds() {
      try {
        const condition = {};
        const resData = await skinService.getSkins(condition);
        this.skins = resData;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
